import { useEffect, useState, useRef } from "react";
import style from "./PathCoursesProgressHolder.module.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";

import CourseProgressVerticalCard from "@/features/courses/components/courseProgressVerticalCard/CourseProgressVerticalCard";

function PathCoursesProgressHolder({ courses }) {
	const [activeIndex, setActiveIndex] = useState(0); // Initial active index
	const swiperRef = useRef(null);

	useEffect(() => {
		if (swiperRef.current?.swiper) {
			swiperRef.current.swiper.slideTo(activeIndex, 300);
		}
	}, [activeIndex]);

	return (
		<Swiper
			ref={swiperRef}
			direction="horizontal"
			slidesPerView="auto"
			initialSlide={activeIndex}
			pagination={{ clickable: true }}
			scrollbar={{
				draggable: true,
			}}
			lazyPreloadPrevNext={1}
			keyboard={{
				enabled: true,
				onlyInViewport: true,
			}}
			mousewheel={{
				forceToAxis: true,
			}}
			modules={[Mousewheel]}
			className={style.cards}
		>
			{courses.map((course, index) => (
				<SwiperSlide key={course.slug} className={style.swiperItem}>
					<CourseProgressVerticalCard
						course={course}
						active={index === activeIndex}
					/>
				</SwiperSlide>
			))}
		</Swiper>
	);
}

export default PathCoursesProgressHolder;
